import { Chip } from '@material-ui/core';
import _ from 'lodash';
import React, { PureComponent } from 'react';
import ExpandToggleButton from '../../../../treeComponents/component/ExpandToggleButton';
import { defaultDisplaySetting } from '../../../../treeComponents/component/helpers/preSelectedFilters';
import { getFormattedDates } from '../../../../treeComponents/helper';
import getConceptCountForPhase from '../../../../treeComponents/helper/getConceptCountForPhase';

interface PhaseNodeProps {
  data: any;
  handleExpandNode: Function;
  isExpanded: boolean;
  subjectTab: string;
  viewPlanData:any;
}

const chaptersConceptsStyles = {
  fontSize: '14px',
  // lineHeight: '19px',
  color: '#999',
  marginLeft: '35px',
  // paddingBottom: '8px',
};

const conceptsStyles = {
  fontSize: '14px',
  // lineHeight: '19px',
  color: '#999',
  // paddingBottom: '8px',
};

const subjectNameStyles = {
  fontSize: '16px',
  // marginRight: '1%',
  // paddingBottom: '3px',
  // lineHeight: '20px'
};
const bullets1 = {
  color: '#C4C4C4',
  padding: '0px 10px',
};
const bullets = {
  color: '#C4C4C4',
  padding: '0px 10px',
  // marginTop: '5px',
  paddingTop:2,
};
const phaseName = {
  color: '#333',
  fontSize: '20px',
  // lineHeight: '27px',
  // marginBottom: '10px',
  // display: 'inline-block',
  // verticalAlign: 'super',
  textTransform: "capitalize",  
  paddingTop:2,
};
const dateStyle = {
  color: '#666',
  fontSize: '16px',
  // lineHeight: '18px',
  // marginBottom: '10px',
  // display: 'inline-block',
  paddingTop:2,
};
const editCTC = {
  cursor: 'pointer',
  marginLeft: '12px',
  verticalAlign: '-5px'
};
const disableEditCta={
  cursor: 'pointer',
  marginLeft: '12px',
  opacity:0.5,
};
export const chipStyle ={
  backgroundColor: '#9361dd',
  margin: "0 0 0 10px",
  height: 20,
  minWidth: 52,
  fontSize: 12,
  color: '#fff',
  border: 'none',
};

// const containerLine={
//   display: "flex",
//   alignItems: "center",
//   marginBottom:10,
// };
class PhaseNode extends PureComponent<PhaseNodeProps> {
  getIndex = (subjectName: string) => {
    const subjects = this.props.data.subjects;
    for (let i = 0; i < subjects.length; i++) {
      if (subjects[i].name === subjectName) return i;
    }
    return -1;
  };

  getConceptCount = () => {
    try {
      const {
        data: { children, subjects },
        subjectTab,
      } = this.props;
      // initialize all concept count to 0
      subjects.forEach((subject: any) => (subject.conceptCount = 0));
      //for each week
      children.forEach((week: any) => {
        //for each chapter
        week.children.forEach((chapter: any) => {
          //get index of subject and add count of concepts in that chapter
          subjects[this.getIndex(chapter.subjectName)].conceptCount += chapter.concepts.length;
        });
      });

      if (subjectTab === 'All Subjects') {
        return subjects.map((subject: any) => (
          <div
            style={{
              display: "flex",
              marginLeft: "2%",
              alignItems: "center",
              paddingBottom: 10,
              padding: "7px 0",
            }}
            key={subject.name}
          >
            <span style={subjectNameStyles}>{subject.name}</span>
            {/* <span style={bullets1}>&bull;</span> */}
            <span style={chaptersConceptsStyles}>{subject.chapterCount} Chapters  </span>
            <span style={bullets}>&bull;</span>
            <span style={conceptsStyles}>{subject.conceptCount} Concepts</span>
          </div>
        ));
      }

      for (let i = 0; i < subjects.length; i++) {
        if (subjects[i].name === subjectTab) {
          return (
            <div
              style={{
                display: "flex",
                marginLeft: "2%",
                alignItems: "center",
                paddingBottom: 10,
                padding: "7px 0",
              }}
              key={subjects[i].name}
            >
              <span style={subjectNameStyles}>{subjects[i].name}</span>
              <span style={chaptersConceptsStyles}>
                {subjects[i].chapterCount} Chapters&nbsp;
                {subjects[i].conceptCount} Concepts
              </span>
              <span style={bullets}>&bull;</span>
            </div>
          );
        }
      }
    } catch (error) {
      return <span style={chaptersConceptsStyles}>{`0 Chapters 0 Concepts`}</span>;
    }
  };

  componentWillUnmount() {
    if (this.props.isExpanded) {
      this.props.handleExpandNode();
    }
  }

  render = () => {
    const { data, handleExpandNode, isExpanded,viewPlanData } = this.props;
    const { startDate, endDate, children, content } = data;
    const hasValidChildren = (children && children.length) || (content && content.length);
    const displaySettings=_.get(viewPlanData,"displaySettings",defaultDisplaySetting);
    return (
      <span style={{ lineHeight: "1" }}>
        <span>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            {hasValidChildren ? (
              <ExpandToggleButton
                handleClick={handleExpandNode}
                isExpanded={isExpanded}
              />
            ) : (
              <></>
            )}
            <span style={phaseName}>{data.name} </span>
            {data.isRevision ?

                  <Chip
                  label='Revision'
                  // className={[classes.chip, classes.chipStyle].join(" ")}
                  style={chipStyle}
                  component="a"
                  variant="outlined"
                  />: <></>}
            <span style={bullets}>&bull;</span>
            <span style={dateStyle}>
              {getFormattedDates(startDate, endDate)}
            </span>
          </span>
          <div>{getConceptCountForPhase(data, this.props.subjectTab,displaySettings)}</div>
        </span>
      </span>
    );
  };
}

export default PhaseNode;
